module.exports = __webpack_public_path__ + "static/media/1020650.7e02487c.png";